module.exports = "/_next/static/images/discount-e7869216ae76bf6c54032c1b7c99dbaa.svg";